<template>
  <div class="opera-indexDesc">
    <topNav :title="$t('indexDesc_title')"></topNav>
    <div class="tipBar">
      <mt-cell :title="$t('indexDesc_total_revenue')">{{$t('indexDesc_total_revenue_value')}}<br>{{$t('indexDesc_total_revenue_value1')}}
      </mt-cell>
      <mt-cell :title="$t('indexDesc_available')"
               :value="$t('indexDesc_available_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_take_up_room')"
               :value="$t('indexDesc_take_up_room_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_overnight_rate')"
               :value="$t('indexDesc_overnight_rate_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_night_average')"
               :value="$t('indexDesc_night_average_value')"></mt-cell>
      <mt-cell title="REVPAR"
               :value="$t('indexDesc_REVPAR_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_total_rooms')"
               :value="$t('indexDesc_total_rooms_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_since_room')"
               :value="$t('indexDesc_since_room_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_free_room')"
               :value="$t('indexDesc_free_room_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_maintenance_room')"
               :value="$t('indexDesc_maintenance_room_value')"></mt-cell>
      <mt-cell :title="$t('indexDesc_locked_room')"
               :value="$t('indexDesc_locked_room_value')"></mt-cell>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    }
  }
</script>
<style lang='less'>
  .opera-indexDesc {
    background-color: #F6F8F9;

    .tipBar {
      margin-top: 0.4rem;
    }

    .mint-cell-value {
      font-size: 0.35rem;
    }
  }
</style>



// WEBPACK FOOTER //
// indexDesc.vue?3de10c4d